module.exports = {"341122100":"新安镇","341122101":"半塔镇","341122102":"水口镇","341122103":"汊河镇","341122104":"大英镇","341122105":"雷官镇","341122106":"施官镇","341122107":"舜山镇","341122200":"三城乡","341122201":"独山乡","341122202":"张山乡","341122203":"杨郢乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341122.json
// module id = 1023
// module chunks = 0